const screens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1536px',
}

const useMatchMedia = {
  methods: {
    /**
     *
     * @param {String} media - sm | md | lg | xl
     * @returns
     */
    useMatchMedia(media) {
      const mediaQuery = `(max-width: ${screens[media]})`
      const mediaQueryList = window.matchMedia(mediaQuery)

      if (mediaQueryList.matches) {
        // Viewport is less or equal to media
        return true
      } else {
        // Viewport is greater than media
        return false
      }
    },
  },
}

export { useMatchMedia }
